import type { ButtonHTMLAttributes } from "react";

/* Minimal stand-in for the shadcn/ui Button used by the original build. */
export default function Button({
  className = "",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      /* Only behaviour-neutral classes here. Size, padding and radius are left
         to the caller (`.pill` etc): utilities are emitted after the components
         layer, so anything set here silently overrides `.pill`. */
      className={`inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 ${className}`}
      {...props}
    />
  );
}
